import { useDialog } from '@works-web/settings/modules/dialog';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { Layer, TimeInput, Toggle } from '~/settings/__modules__/component';

TimeSetting.propTypes = {
  onCancle: PropTypes.func,
  onOk: PropTypes.func,
  defaultValue: PropTypes.object.isRequired,
};

const checkAndFormatTime = (time = '') => {
  let timeArr = time.split(':');
  const reg = /^[0-9]{2}$/;
  if (timeArr && timeArr.length == 2) {
    let [hour, minute] = timeArr.map((item) => {
      if (reg.test(item)) {
        return parseInt(item);
      } else {
        return NaN;
      }
    });
    if (
      !isNaN(hour) &&
      !isNaN(minute) &&
      hour >= 0 &&
      hour < 24 &&
      minute >= 0 &&
      minute < 60
    ) {
      return { hour, minute };
    }
  }
  return null;
};

export function TimeSetting({ onCancle, onOk, defaultValue }) {
  const dialog = useDialog();
  const { t } = useTranslation();
  const WEEK = [
    { label: t('talk_mon1'), value: 1 },
    { label: t('talk_tue1'), value: 2 },
    { label: t('talk_wed1'), value: 3 },
    { label: t('talk_thu1'), value: 4 },
    { label: t('talk_fri1'), value: 5 },
    { label: t('talk_sat1'), value: 6 },
    { label: t('talk_sun1'), value: 0 },
  ];

  const [timeOption, setTimeOption] = useState(defaultValue);

  const defaultAlldayEnable =
    defaultValue.startTime === '00:00' && defaultValue.endTime === '23:59';
  const [alldayEnable, setAlldayEnable] = useState(defaultAlldayEnable);

  const onWeekChange = (week) => {
    const weekdays = [...timeOption.weekdays];
    const index = weekdays.indexOf(week);
    if (index > -1 && weekdays.length === 1) {
      showDialog(t('talk_reply_alert4'));
      return;
    }
    if (index > -1) {
      weekdays.splice(index, 1);
    } else {
      weekdays.push(week);
    }
    setTimeOption({
      ...timeOption,
      weekdays,
    });
  };
  const onTimeChange = (key, value) => {
    setTimeOption({
      ...timeOption,
      [key]: value,
    });
  };

  const onSave = () => {
    let params = { ...timeOption };
    if (alldayEnable) {
      params.startTime = '00:00';
      params.endTime = '23:59';
    }
    const start = checkAndFormatTime(params.startTime);
    const end = checkAndFormatTime(params.endTime);
    if (!start || !end) {
      showDialog(<Trans i18nKey="talk_reply_alert1" />);
      return;
    } else if (start.hour === end.hour && start.minute === end.minute) {
      showDialog(<Trans i18nKey="talk_reply_alert2" />);
      return;
    }
    params.weekdays = params.weekdays.sort();
    onOk(params);
  };

  const showDialog = (title = '') => {
    dialog.alert((action) => ({
      title,
      description: '',
      [action()]: (close) => {
        close && close();
      },
    }));
  };

  return (
    <Layer className="ly_auto_reply">
      <h3 className="title">{t('talk_reply_time')}</h3>
      <div className="layer_contents">
        <ul className="days_list">
          {WEEK.map((item) => {
            return (
              <li
                className="item"
                key={item.label + item.value}
                onClick={() => onWeekChange(item.value)}
              >
                <input
                  type="checkbox"
                  className="days_checkbox"
                  checked={timeOption.weekdays.includes(item.value)}
                  onChange={() => {}}
                />
                <label>{item.label}</label>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="option_box">
        <strong className="title">{t('talk_reply_allday')}</strong>
        <Toggle
          value={alldayEnable}
          label={'all day'}
          onChange={() => setAlldayEnable(!alldayEnable)}
        />
      </div>
      {!alldayEnable && (
        <div className="time_box">
          <TimeInput
            value={timeOption.startTime}
            onChange={(event) => onTimeChange('startTime', event.target.value)}
          />
          <span className="hyphen">
            <i className="blind">-</i>
          </span>
          <TimeInput
            value={timeOption.endTime}
            onChange={(event) => onTimeChange('endTime', event.target.value)}
          />
        </div>
      )}
      <div className="btn_area">
        <button type="button" className="lw_btn_40" onClick={() => onCancle()}>
          {t('button_cancel')}
        </button>
        <button
          type="button"
          className="lw_btn_point_40"
          onClick={() => onSave()}
        >
          {t('button_save')}
        </button>
      </div>
      <button type="button" className="btn_close" onClick={() => onCancle()}>
        {t('button_close')}
      </button>
    </Layer>
  );
}
